import { Auth } from '@ax/auth';
import { PROJECT_ENVIRONMENT } from '@ax/env';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

declare global {
  interface Window {
    Webnrtsdk: any;
  }
}

export interface StartRecordingParams {
  docId: string;
  noteId: string;
  streamType: string;
  clientType: string;
  shouldTranscript: boolean;
  chunkDuration: number;
}

interface NrtInstance {
  sdkInstance: any;
  startRecording: (params: StartRecordingParams) => void;
  stopRecording: () => void;
  releaseSdk: () => void;
}

const useNrtInstance = (): NrtInstance => {
  const [sdkInstance, setSdkInstance] = useState<any>(null);

  const startRecording = (params: StartRecordingParams) => {
    if (sdkInstance) {
      sdkInstance.startRecording(
        params.docId,
        params.noteId,
        params.streamType,
        params.clientType,
        params.shouldTranscript,
        params.chunkDuration,
      );
    }
  };

  const stopRecording = () => {
    if (sdkInstance) {
      sdkInstance.stopRecording(true);
    }
  };

  const releaseSdk = () => {
    if (sdkInstance) {
      sdkInstance.releaseNrtSdk();
    }
  };

  useEffect(() => {
    const eventHandler = new window.Webnrtsdk.NrtEventHandler(onstart, onstop, onerror);
    const instance = new window.Webnrtsdk.Nrtsdk(
      {
        nrtServerURL: PROJECT_ENVIRONMENT.API['nrt-api'].base_url,
        authToken: Auth.getAccessToken() ?? '',
      },
      eventHandler,
    );
    setSdkInstance(instance);

    return () => {
      if (instance) {
        instance.releaseNrtSdk();
      }
    };
  }, []);

  const onstart = () => {
    toast('Recording started');
  };
  const onstop = () => {
    toast('Recording stopped');

    setTimeout(() => {
      toast('Transcript is processing...');
    }, 4000);
  };

  const onerror = (err: any) => {
    console.error(err);
  };

  return {
    sdkInstance,
    startRecording,
    stopRecording,
    releaseSdk,
  };
};

export default useNrtInstance;
